import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import * as React from 'react';
// @mui
import { Container, Typography, Stack, Button, IconButton, Chip, FormControl, Select, MenuItem } from '@mui/material';
// Tabela
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Iconify from '../../../components/iconify';
import FilterField from '../components/FilterField';

// api
import { validateUser, updateGenericData, getGenericData, deleteGenericData, acaoGrupoDespesas } from '../../api';
import config from '../../../config.json';
import PopoverFiltroBasico from '../../PopoverFiltroBasico';
import ModalLoading from '../../ModalLoading';
import ModalConfirmacao from '../../ModalConfirmacao';
import { cores } from '../../../styles/styleUtils';

import NewDespesaForm from '../newDespesa/NewDespesaForm';
import ParcelasFuturasDialog from '../components/ParcelasFuturasDialog';

// ----------------------------------------------------------------------

const STATUS_DESPESA = {
  PENDENTE: 'Pendente',
  VENCIDO: 'Vencido',
  PAGO: 'Pago',
};

const inicioHoje = () => {
  const agora = new Date();
  return new Date(agora.getFullYear(), agora.getMonth(), agora.getDate());
};

const getStatusDespesa = (row) => {
  if (row?.dataPagamento) return STATUS_DESPESA.PAGO;

  if (row?.vencimento) {
    const vencimento = new Date(row.vencimento);
    if (!Number.isNaN(vencimento.getTime()) && vencimento < inicioHoje()) {
      return STATUS_DESPESA.VENCIDO;
    }
  }

  return STATUS_DESPESA.PENDENTE;
};

const statusChipProps = (status) => {
  switch (status) {
    case STATUS_DESPESA.PAGO:
      return { color: 'success', variant: 'filled' };
    case STATUS_DESPESA.VENCIDO:
      return { color: 'error', variant: 'filled' };
    default:
      return { color: 'default', variant: 'outlined' };
  }
};

export default function Despesas({ dateToOpen }) {
  const [propostas, setPropostas] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [inclusao, setInclusao] = useState(false);
  const [isNewSaleModalOpen, setIsNewSaleModalOpen] = useState(false);
  const [produto, setProduto] = React.useState(null);
  const usuarioLogado = JSON.parse(localStorage.getItem('userData'));
  const [modalConfirmacaoDelete, setModalConfirmacaoDelete] = useState(false);
  const [registroGrupo, setRegistroGrupo] = useState(null);
  const navigate = useNavigate();
  // Filtro ----
  const dataAtual = new Date();
  const primeiroDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
  const ultimoDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0);
  const emptyFiltro = {
    usuarioLogado,
    datainicial: primeiroDiaDoMes,
    datafinal: ultimoDiaDoMes,
  };
  // const [filtro, setFiltro] = useState({ ...emptyFiltro, vencimento: dateToOpen });
  const [filtro, setFiltro] = useState(dateToOpen ? { vencimento: dateToOpen } : { ...emptyFiltro });
  const [openFiltro, setOpenFiltro] = useState(null);

  useEffect(() => {
    validateuser();
  }, []);
  const validateuser = async () => {
    const teste = await validateUser();
    if (!teste.ok) {
      localStorage.removeItem('userData');
      localStorage.removeItem('userToken');
      config.user = {};
      navigate('/', { replace: true });
      window.alert('Sessão expirada, faça o login novamente');
      return;
    }
    localStorage.setItem('userData', JSON.stringify(teste.usuario));
    config.user = teste.usuario;
  };

  useEffect(() => {
    fGetPropostas(filtro);
  }, [filtro]);

  const fGetPropostas = (filtro) => {
    getGenericData('despesa', filtro)
      .then((dados) => {
        setPropostas(dados);
      })
      .catch((error) => {
        // Trate erros aqui
        window.alert('Erro ao consultar banco de dados');
        console.error('Erro ao buscar dados da API:', error);
      });
  };

  const handleOpenNewSaleModal = () => {
    setIsNewSaleModalOpen(true);
    setInclusao(true);
  };

  const handleCloseNewSaleModal = () => {
    setProduto(null);
    setIsNewSaleModalOpen(false);
    setInclusao(false);
  };

  const handleDoubleClickTable = async (row) => {
    setProduto({ ...row, visualiza: true });
    setIsNewSaleModalOpen(true);
  };

  const onCloseFiltro = () => {
    setOpenFiltro(null);
  };

  const limparFiltro = () => {
    setFiltro({ ...emptyFiltro });
    setOpenFiltro(null);
  };

  const onConfirmFiltro = (filtroPopover) => {
    setFiltro(filtroPopover);
    setOpenFiltro(null);
  };

  const handleDeleteClick = (row) => {
    setProduto({ ...row });
    setModalConfirmacaoDelete(true);
  };

  const closeModalConfirmacaDelete = () => {
    setModalConfirmacaoDelete(false);
    setProduto(null);
  };

  const confirmDelete = async () => {
    const motivo = window.prompt('Informe o motivo do cancelamento da despesa:');
    if (!motivo || motivo.trim().length < 3) {
      window.alert('O cancelamento não foi realizado. Informe um motivo válido.');
      return;
    }

    setModalLoading(true);
    const resultado = await deleteGenericData('despesa', {
      ...produto,
      motivoCancelamento: motivo.trim(),
    });
    setModalLoading(false);

    if (resultado?.success === false || resultado?.ok === false) {
      window.alert(resultado?.message || resultado?.msg || 'Não foi possível cancelar a despesa.');
      return;
    }

    closeModalConfirmacaDelete();
    fGetPropostas(filtro);
    setProduto(null);
  };

  const onConfirmNewSale = async (data) => {
    await updateGenericData('despesa', data);
    fGetPropostas(filtro);
    handleCloseNewSaleModal();
  };

  // Novo estado para o termo de busca
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('Todos');
  // Novo estado para os dados filtrados
  const [filteredPropostas, setFilteredPropostas] = useState([]);

  // Este useEffect reagirá a mudanças em 'propostas' ou 'searchTerm'
  useEffect(() => {
    const termo = searchTerm.toLowerCase();

    const results = propostas.filter((row) => {
      const descricaoMatch = row.codigoDespesa?.toLowerCase().includes(termo);
      const fornecedorMatch = row.despesa?.toLowerCase().includes(termo);
      const status = getStatusDespesa(row);
      const statusMatch = statusFilter === 'Todos' || status === statusFilter;
      return (descricaoMatch || fornecedorMatch) && statusMatch;
    });

    setFilteredPropostas(results);
  }, [searchTerm, propostas, statusFilter]);
  // ----------------------

  return (
    <>
      <Helmet>
        <title> Despesas </title>
      </Helmet>

      <Container maxWidth="xl">
        {!dateToOpen && (
          <Stack direction={'row'} justifyContent={'space-between'}>
            <Typography variant="h4" sx={{ mb: 5 }}>
              Despesas
            </Typography>

            <Button
              onClick={(e) => setOpenFiltro(e.currentTarget)}
              variant="contained"
              startIcon={<Iconify icon="eva:search-fill" />}
              sx={{
                height: 50,
                minWidth: 100,
                backgroundColor: cores.laranja,
                marginLeft: 'auto',
                '&:hover': { backgroundColor: cores.laranjaEscuro },
              }}
            >
              Filtros
            </Button>

            <Button
              variant="contained"
              onClick={handleOpenNewSaleModal}
              startIcon={<Iconify icon="zondicons:add-solid" />}
              sx={{ height: 50, minWidth: 100, marginLeft: 1 }}
            >
              Adicionar
            </Button>
          </Stack>
        )}

        {/* Campo de texto para filtro */}
        {!dateToOpen && (
          <>
            <FilterField setSearchTerm={setSearchTerm} searchTerm={searchTerm} label={'Filtrar por Código ou Despesa'} />
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2, mt: 1 }}>
              <Typography variant="body2">Status:</Typography>
              <FormControl size="small" sx={{ minWidth: 170 }}>
                <Select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                  <MenuItem value="Todos">Todos</MenuItem>
                  <MenuItem value={STATUS_DESPESA.PENDENTE}>Pendente</MenuItem>
                  <MenuItem value={STATUS_DESPESA.VENCIDO}>Vencido</MenuItem>
                  <MenuItem value={STATUS_DESPESA.PAGO}>Pago</MenuItem>
                </Select>
              </FormControl>
            </Stack>
          </>
        )}

        {/* ------------ Tabela ------------ */}
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Codigo</TableCell>
                <TableCell align="left">Despesa</TableCell>
                <TableCell align="left">Unidade</TableCell>
                <TableCell align="left">Centro de Custo</TableCell>
                <TableCell align="center">Parcela</TableCell>
                <TableCell align="center">Vencimento</TableCell>
                <TableCell align="center">Valor</TableCell>
                <TableCell align="center">Pagamento</TableCell>
                <TableCell align="center">Status</TableCell>
                {usuarioLogado.supervisor && <TableCell align="center">Futuras</TableCell>}
                {usuarioLogado.supervisor && <TableCell align="center">Cancelar</TableCell>}
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredPropostas.map((row, index) => {
                const status = getStatusDespesa(row);
                const chipProps = statusChipProps(status);

                return (
                <TableRow
                  key={index}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 },
                    '&:hover': { backgroundColor: cores.cinzaClaro },
                    ...(row.finalizado?.nome === 'Rejeitado' && {
                      color: 'red',
                      textDecoration: 'line-through',
                    }),
                  }}
                  onDoubleClick={() => handleDoubleClickTable(row)}
                >
                  <TableCell align="left">{row.codigoDespesa}</TableCell>
                  <TableCell align="left">{row.despesa}</TableCell>
                  <TableCell align="left">{row.unidade?.nome}</TableCell>
                  <TableCell align="left">{row.centroCusto?.nome}</TableCell>
                  <TableCell align="center">{`${row.parcela}/${row.parcelas}`}</TableCell>
                  <TableCell align="center">
                    {row.vencimento
                      ? new Date(row.vencimento).toLocaleDateString('pt-BR', {
                          timeZone: 'America/Sao_Paulo',
                        })
                      : ''}
                  </TableCell>
                  <TableCell align="center">
                    {row.valorBaixa?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </TableCell>
                  <TableCell align="center">
                    {row.dataPagamento
                      ? new Date(row.dataPagamento).toLocaleDateString('pt-BR', {
                          timeZone: 'America/Sao_Paulo',
                        })
                      : ''}
                  </TableCell>
                  <TableCell align="center">
                    <Chip label={status} size="small" {...chipProps} />
                  </TableCell>
                  {usuarioLogado.supervisor && (
                    <TableCell align="center">
                      {row.grupoDespesaId && !row.idVenda && !row.dataPagamento ? (
                        <IconButton
                          title="Alterar/cancelar futuras"
                          onClick={() => setRegistroGrupo(row)}
                        >
                          <Iconify icon="eva:calendar-outline" width={22} height={22} />
                        </IconButton>
                      ) : null}
                    </TableCell>
                  )}
                  {/* Ícone de cancelamento visível apenas para supervisores */}
                  {usuarioLogado.supervisor && !row.idVenda && (
                    <TableCell align="center">
                      <IconButton onClick={() => handleDeleteClick(row)}>
                        <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                      </IconButton>
                    </TableCell>
                  )}
                </TableRow>
                );
              })}
              <TableRow>
                <TableCell align="left" colSpan={4}>
                  <strong>Total</strong>
                </TableCell>
                <TableCell align="center">
                  Quantidade: <strong>{filteredPropostas.length}</strong>
                </TableCell>
                <TableCell />
                <TableCell align="center">
                  <strong>
                    {filteredPropostas
                      .reduce((acc, curr) => acc + (curr.valorBaixa || curr.valor || 0), 0)
                      .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </strong>
                </TableCell>
                <TableCell />
                <TableCell />
                {usuarioLogado.supervisor && <TableCell />}
                {usuarioLogado.supervisor && <TableCell />}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      {openFiltro ? (
        <PopoverFiltroBasico
          filtro={filtro}
          open={openFiltro}
          onClose={onCloseFiltro}
          onLimpar={limparFiltro}
          onConfirm={onConfirmFiltro}
          type={'despesa'}
        />
      ) : null}
      {/* Modal Loading */}
      {modalLoading && <ModalLoading open={modalLoading} />}

      {modalConfirmacaoDelete ? (
        <ModalConfirmacao
          title={'Tem certeza que deseja cancelar essa despesa?'}
          subtitle={`Codigo: ${produto.codigoDespesa}  |  Vencimento: ${new Date(
            produto.vencimento
          ).toLocaleDateString()} | Valor: ${parseFloat(produto.valorBaixa).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`}
          open={modalConfirmacaoDelete}
          onClose={closeModalConfirmacaDelete}
          onConfirm={confirmDelete}
        />
      ) : null}

      {registroGrupo && (
        <ParcelasFuturasDialog
          open={Boolean(registroGrupo)}
          onClose={() => setRegistroGrupo(null)}
          registro={registroGrupo}
          tipo="despesa"
          previewFn={acaoGrupoDespesas}
          executeFn={acaoGrupoDespesas}
          permiteCancelar
          permiteValor
          onSuccess={() => fGetPropostas(filtro)}
        />
      )}

      {isNewSaleModalOpen && (
        <NewDespesaForm
          open={isNewSaleModalOpen}
          formData={produto}
          handleClose={handleCloseNewSaleModal}
          onConfirm={onConfirmNewSale}
          onInclusao={inclusao}
          onEstornoConcluido={() => fGetPropostas(filtro)}
        />
      )}
    </>
  );
}